import { RootState } from "../../store"

export const getAuthState = (state: RootState) => state.auth
export const getAuthUser = (state: RootState) => state.auth.user
export const getDateFormat = (state: RootState) => state.auth.user?.dateFormat
export const getDateFormatSeparator = (state: RootState) => {
  return state.auth.user?.dateFormatSeparator
}
